export default defineNuxtPlugin(() => {
    const { t } = useNuxtApp().$i18n;

    return {
        provide: {
            rulesFieldRequired(value: string | null | undefined): true | string {
                return !!value || t('validation.field.default');//이 필드는 필수 입력 사항입니다.
            },

            rulesFieldId(value: string): true | string {
                return /^[a-zA-Z0-9._%+-]+$/.test(value) || t('validation.field.default');//아이디는 영문 또는 숫자만 입력해주세요.
            },

            rulesFieldPhone(value: string): true | string {
                return /^\d{3}-\d{4}-\d{4}$/.test(value) || t('validation.field.phone');//휴대폰 번호는 xxx-xxxx-xxxx 형식으로 입력해주세요.
            },

            rulesFieldEmailLocal(value: string): true | string {
                return /^[a-zA-Z0-9._%+-]+$/.test(value) || t('validation.field.emailLocal');//이메일 아이디는 영문 또는 숫자만 입력해주세요.
            },

            rulesFiledEmailDomain(value: string): true | string {
                return /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value) || t('validation.field.emailDomain');//이메일 도메인을 올바르게 입력해주세요.
            },

            rulesFieldNumber(value: string): true | string {
                return /^-?[0-9.]*$/.test(value) || t('validation.field.number');//숫자, 소수점, 마이너스만 입력 가능합니다.
            },

            rulesInFieldInteger(value: string): true | string {
                return /^[0-9]*$/.test(value) || t('validation.field.integer');//정수만 입력 가능합니다.
            },

            rulesFieldPassword(value: string): true | string {
                const pwd = value || ''
                // 영문 대소문자, 숫자, 특수문자 각각 최소 1회 포함, 전체 길이 8~20
                const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-[\]{};':"\\|,.<>\/?`~]).{8,20}$/
                return regex.test(pwd) || t('validation.field.password');//비밀번호는 영문, 숫자, 특수문자를 모두 사용하여 8~20자리로 입력하세요'
            },

            formatInputId(value: string): string {
                const filterId = value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '');
                return filterId;
            },

            formatPhoneNumber(value: string): string {
                const numbersOnly = value.replace(/\D/g, '');

                if (numbersOnly.length <= 3) {
                    return numbersOnly;
                } else if (numbersOnly.length <= 7) {
                    return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3)}`;
                } else {
                    return `${numbersOnly.slice(0, 3)}-${numbersOnly.slice(3, 7)}-${numbersOnly.slice(7, 11)}`;
                }
            },
        },
    };
});